
define('jsx!components/login-portal/input-domain',["react"], function (React)
{
	return React.createClass({
		displayName: "Domain",
		getDefaultProps: function ()
		{
			return {
				"valid": null,
				"tenant": null,
				"setTenant": function () {},
				"incrementProgress": function () {},
				"decrementProgress": function () {},
				"handleEnterKeyUp": function () {},
				"setErrorMessage": function () {},
				"isPebbleGoPortal": false
			};
		},
		getInitialState: function ()
		{
			return {
				"domain": this.props.tenant && this.props.tenant.canonical_name || null,
				"valid": null,
				"help_message": null
			};
		},
		handleChangeOnDomain: function (e)
		{
			var domain = e.currentTarget.value.trim();
			domain = domain.replace(/[^a-z0-9\-]/gi, "");

			this.setState({
				"domain": domain,
				"valid": false
			});

			if (this.validationTimeout) {
				clearTimeout(this.validationTimeout);
			}

			this.props.setTenant(null);
			this.validationTimeout = setTimeout(this.validateDomain, 250);
		},
		handleKeyUpOnDomain: function (e)
		{
			if (e.charCode == 13 || e.keyCode == 13 || e.key == 13 || e.which == 13) {
				if (this.state.valid) {
					this.props.handleEnterKeyUp();
				}
			}
		},
		validateDomain: function ()
		{
			try {
				if (typeof this.state.domain !== "string" || this.state.domain.length == 0) {
					throw new Error("Please enter a domain.");
				}

				if (this.state.domain.length > 64) {
					throw new Error("Domain is too long.");
				}

				/*
				 * Make a request to the API and see if the domain exists.
				 */
				if (this.validateDomainExistsTimeout) {
					clearTimeout(this.validateDomainExistsTimeout);
				}
				this.validateDomainExistsTimeout = setTimeout(this.validateDomainExists, 100);
			} catch (err) {
				this.props.setTenant(null);
				this.setState({
					"valid": false,
					"help_message": err.message
				});
			}
		},
		validateDomainExists: function ()
		{
			var self = this;
			var requestId = Date.now();
			this.validationRequestId = requestId;

			var apiURL = "https://" + window.appData.config.api_base_uri.replace("{client}", this.state.domain);

			$.get(apiURL + "/client")
			.done(function (response) {
				if (self.validationRequestId !== requestId) {
					return;
				}

				self.props.setTenant(response.data);
				self.setState({
					"valid": true,
					"help_message": null
				});
			})
			.fail(function (jqXHR) {
				if (self.validationRequestId !== requestId) {
					return;
				}

				self.setState({
					"valid": false,
					"help_message": self.props.isPebbleGoPortal ? "Domain is invalid. Try again" : "Domain does not exist."
				});
			})
			.always(function () {
				this.validationRequestId = null;
			});
		},
		componentDidUpdate: function (prevProps, prevState)
		{
			if (!prevState.valid && this.state.valid === true) {
				this.props.incrementProgress();
			} else if (!this.state.valid && prevState.valid === true) {
				this.props.decrementProgress();
			}
		},
		renderHelpBlock: function ()
		{
			if (this.state.valid) {
				return null;
			}

			return (
				React.createElement("span", {className: "help-block"}, this.state.help_message)
			);
		},
		render: function ()
		{
			var classNames = ['form-group'];
			
			if (this.props.isPebbleGoPortal) {
				classNames.push("domain");

				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("input", {
							type: "text", 
							className: "tenant-input", 
							name: "domain", 
							id: "input-domain", 
							value:  this.state.domain, 
							onChange:  this.handleChangeOnDomain, 
							onKeyUp:  this.handleKeyUpOnDomain, 
							autoFocus: true}
							), 
						React.createElement("span", {className: "buncee-domain"},  window.appData.config.web_base_uri.replace("{client}", "") )
					)
				);
			} else  {
				if (this.state.valid === true) {
					classNames.push("has-success");
				} else if (this.state.valid === false) {
					classNames.push("has-error");
				}
	
				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("input", {
							type: "text", 
							className: "form-control", 
							name: "domain", 
							placeholder: "Enter a domain...", 
							id: "input-domain", 
							value:  this.state.domain, 
							onChange:  this.handleChangeOnDomain, 
							onKeyUp:  this.handleKeyUpOnDomain, 
							style: { "width": "50%", "display":"inline-block", 'margin-right': '15px'}}), 
						React.createElement("span", {style: { "fontSize": "24px", "lineHeight": "48px"}},  window.appData.config.web_base_uri.replace("{client}", "") ), 
						 this.renderHelpBlock() 
					)
				);
			}
		}
	});
});
